<!-- Preloader -->
<div id="preloader" *ngIf="visibility">
	<div id="loader"></div>
</div>
<!-- End Preloader -->
